import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import { useLanguage } from "../i18n/LanguageContext";

export const ProtectedRoute = ({ children }) => {
  const { user, loading, configured } = useAuth();
  const { portal } = useLanguage();

  if (!configured) {
    return (
      <div className="auth-page">
        <div className="auth-card">
          <h1>{portal.protected.firebaseTitle}</h1>
          <p>{portal.protected.firebaseBody}</p>
        </div>
      </div>
    );
  }

  if (loading) {
    return (
      <div className="auth-page">
        <div className="auth-card">
          <p>{portal.common.loading}</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return children;
};
